import { createFileRoute } from '@tanstack/react-router';
import { MainContents } from '@/components/MainContents';
import Loading from '@/components/Loading';
import useFetchJobPostImportRequest from '@/features/agent/provided_job_posts/api/useFetchJobPostImportRequest';
import { TextImportProcessingStatus } from './TextImportProcessingStatus';
import { TextImportFailedStatus } from './TextImportFailedStatus';
import { TextImportCompletedStatus } from './TextImportCompletedStatus';

export const Route = createFileRoute('/agent/provided_job_posts/new/text/$id')({
  component: ProvidedJobPostsNewTextPolling,
  staticData: { title: 'テキストから取り込み' },
});

function ProvidedJobPostsNewTextPolling() {
  const { id } = Route.useParams();
  const {
    data: importRequest,
    isLoading,
    error,
  } = useFetchJobPostImportRequest(id, {
    pollUntilComplete: true,
  });

  if (error) {
    return (
      <MainContents>
        <div className="flex min-h-screen flex-col bg-white p-6">
          <h1 className="text-xl leading-[1.4] font-bold text-main">エラーが発生しました</h1>
          <p className="mt-2 text-sm text-sub">
            {error instanceof Error ? error.message : '処理の取得に失敗しました'}
          </p>
        </div>
      </MainContents>
    );
  }

  if (isLoading || !importRequest) {
    return (
      <MainContents>
        <div className="flex min-h-screen flex-col items-center justify-center bg-white p-6">
          <Loading />
        </div>
      </MainContents>
    );
  }

  if (importRequest.status === 'failed') {
    const metaError = importRequest.meta?.error;
    return (
      <TextImportFailedStatus
        errorMessage={typeof metaError === 'string' ? metaError : undefined}
      />
    );
  }

  if (importRequest.status === 'completed') {
    const meta = importRequest.meta;
    const title = typeof meta?.title === 'string' ? meta?.title : undefined;
    const jobContent = Array.isArray(meta?.job_content) ? meta?.job_content : undefined;
    const workingLocation =
      typeof meta?.working_location === 'string' ? meta?.working_location : undefined;
    const jobPositionName =
      typeof meta?.job_position_name === 'string' ? meta?.job_position_name : undefined;
    const minSalary = typeof meta?.min_salary === 'number' ? meta?.min_salary : undefined;
    const maxSalary = typeof meta?.max_salary === 'number' ? meta?.max_salary : undefined;

    return (
      <TextImportCompletedStatus
        title={title}
        jobContent={jobContent}
        workingLocation={workingLocation}
        jobPositionName={jobPositionName}
        minSalary={minSalary}
        maxSalary={maxSalary}
      />
    );
  }

  // processing または draft の場合
  return <TextImportProcessingStatus />;
}
